import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import axiosClient from '../../api/axiosClient';
import { Mail, Send, MapPin, CheckCircle, Shield } from 'lucide-react';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const mutation = useMutation({
    mutationFn: (data) => axiosClient.post('/public/contact', data),
    onSuccess: () => setSent(true),
    onError: () => alert("Transmission failed. Please try again.")
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate(form);
  };

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center pt-24 pb-12 px-4">
      <div className="max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-12">
        
        {/* Info Side */}
        <div className="space-y-8">
          <div>
            <h1 className="text-4xl font-black text-white mb-4">Secure Comms</h1>
            <p className="text-slate-400 text-lg">
              Reach the AIRS Security. All messages are encrypted and handled by our security operations team.
            </p>
          </div>

          <div className="space-y-4">
            <div className="flex items-start">
              <div className="bg-blue-900/30 p-3 rounded-lg mr-4 text-teal-400"><MapPin className="w-6 h-6"/></div>
              <div>
                <h4 className="text-white font-bold">Office</h4>
                <p className="text-slate-400">
                  Plot No. 21, Basant Vihar Colony, Mini Bypass Road,<br />
                  Near Reshma Hospital, Izatnagar,<br />
                  Bareilly, Uttar Pradesh 243001, India
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="bg-blue-900/30 p-3 rounded-lg mr-4 text-teal-400"><Mail className="w-6 h-6"/></div>
              <div>
                <h4 className="text-white font-bold">Email Uplink</h4>
                <p className="text-slate-400">support@airssecurity.com</p>
                <p className="text-slate-400">contact@appence.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Form Side */}
        <div className="bg-[#0f172a] p-8 rounded-2xl border border-slate-800 shadow-2xl">
          {sent ? (
            <div className="text-center py-12 animate-in zoom-in">
              <div className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-green-500"/>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">Message Received</h3>
              <p className="text-slate-400">Our agents will analyze your request shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                <Shield className="w-5 h-5 mr-2 text-teal-500"/> Open Ticket
              </h3>
              
              <div className="grid grid-cols-2 gap-4">
                <input 
                  required placeholder="Your Name"
                  className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-blue-500 outline-none transition-colors"
                  value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                />
                <input 
                  required type="email" placeholder="Email Address"
                  className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-blue-500 outline-none transition-colors"
                  value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                />
              </div>
              
              <input 
                required placeholder="Subject / Incident ID"
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-blue-500 outline-none transition-colors"
                value={form.subject} onChange={e => setForm({...form, subject: e.target.value})}
              />
              
              <textarea 
                required placeholder="Describe the issue or security concern..."
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white h-32 focus:border-blue-500 outline-none transition-colors"
                value={form.message} onChange={e => setForm({...form, message: e.target.value})}
              />

              <button 
                disabled={mutation.isLoading}
                className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl transition-all flex items-center justify-center shadow-lg shadow-blue-600/20"
              >
                {mutation.isLoading ? 'Encrypting & Sending...' : <><Send className="w-4 h-4 mr-2"/> Transmit Message</>}
              </button>
            </form>
          )}
        </div>

      </div>
    </div>
  );
};

export default ContactPage;